export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14091.4f3079c2.jpg";